
import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form: {
        id: "",
        tahun: "",
        indikator: "",
        kecamatan: "",
        a: 0,
        b: 0,
        c: 0,
        nama: "",
        jenis: "",
        pagu: 0,
        sumber: "",
        keterangan: "",
        createAt: "",
        editedAt: "",
      },

      tahun: "",
      sumber: "",
      kendala: "",
      total1: "",
      total2: "",
      total3: "",
      total4: "",
      total5: "",
      total6: "",
      total7: "",
      total8: "",
      indikator: "",
      nama_tahun: "",
      nama_kadis: "",
      nip_kadis: "",
      pangkat_kadis: "",
      gol_kadis: "",
      ruang_kadis: "",
      gel_bel_kadis: "",
      gel_dep_kadis: "",

      list_data: [],
      cetak_data: [],
      list_tahun: [],
      list_kecamatan: [],
      list_indikator: [],

      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data: true,

      mdl_add: false,
      mdl_cetak: false,
      mdl_print: false,
      mdl_download: false,
      mdl_edit: false,
      mdl_hapus: false,
      btn_add: false,

      UMUM: UMUM,
    };
  },
  computed: {
    // subTotalCols() {
    //   const cols = this.indikatorSchema.table.sumColumns;
    //   const rows = this.normalizedCetakRows;

    //   const totals = {};

    //   cols.forEach((c) => (totals[c] = 0));

    //   rows.forEach((r) => {
    //     cols.forEach((c) => {
    //       totals[c] += Number(r[c] || 0);
    //     });
    //   });

    //   return totals;
    // },

    nonSumColCount() {
    const body = this.indikatorSchema.table.bodyColumns
    const sumCols = this.indikatorSchema.table.sumColumns || []

    let count = 0

    for (let col of body) {
      if (sumCols.includes(col) || col === 'percentage') {
        break
      }
      count++
    }

    return count
  },

    subTotalCols() {
      const cols = this.indikatorSchema.table.sumColumns;
      const rows = this.normalizedCetakRows;

      const totals = {};

      cols.forEach((c) => (totals[c] = 0));

      rows.forEach((r) => {
        cols.forEach((c) => {
          totals[c] += Number(r[c] || 0);
        });
      });

      return totals;
    },

    grandTotal() {
      const cols =
        this.indikatorSchema.table.sumColumns ||
        this.indikatorSchema.table.bodyColumns;
      return cols.reduce(
        (sum, c) => sum + Number(this.subTotalCols[c] || 0),
        0,
      );
    },
    indikatorSchema() {
      const id = Number(this.form?.indikator?.id);

      // helper cepat
      const num = (v) => Number(v || 0);

      const isCetak = this.mdl_cetak;

      // =========================
      // INDIKATOR 1
      // =========================
      if (id === 1) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Bentuk Penanganan Kawasan Kumuh", colspan: 3 },
                { label: "Total Luasan Yang Ditangani (ha)", rowspan: 2, width: "15%" },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pemugaran (ha)" },
                { label: "Peremajaan (ha)" },
                { label: "Permukiman Kembali (ha)" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["kecamatan", "a", "b", "c", "total"],
            sumColumns: ["a", "b", "c", "total"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Bentuk Penanganan Kawasan Kumuh",
                cols: 3,
                fields: [
                  {
                    key: "a",
                    label: "Pemugaran (ha)",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Peremajaan (ha)",
                    type: "text",
                  },
                  {
                    key: "c",
                    label: "Permukiman Kembali (ha)",
                    type: "text",
                  },
                ],
              },
            ],
            showKec: true,
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);

            return {
              ...row,
              a,
              b,
              c,
              total: a + b + c,
            };
          },
        };
      }
      // =========================
      // INDIKATOR 2
      // =========================
      if (id === 2) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Target Luas Kawasan Kumuh Yang Ditangani Pada Tahun N", colspan: 4 },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Pemugaran (ha)" },
                { label: "Peremajaan (ha)" },
                { label: "Permukiman Kembali (ha)" },
                { label: "Target Luasan Yang Ditangani (ha)" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["kecamatan", "a", "b", "c", "total"],
            sumColumns: ["a", "b", "c", "total"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Target Luas Kawasan Kumuh Yang Ditangani Pada Tahun N",
                cols: 3,
                fields: [
                  {
                    key: "a",
                    label: "Pemugaran (ha)",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Peremajaan (ha)",
                    type: "text",
                  },
                  {
                    key: "c",
                    label: "Permukiman Kembali (ha)",
                    type: "text",
                  },
                ],
              },
            ],
            showKec: true,
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);
            const c = num(row.c);

            return {
              ...row,
              a,
              b,
              c,
              total: a + b + c,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 3
      // =========================
      if (id === 3) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Bentuk Penanganan RTLH", colspan: 2 },
                { label: "Total Jumlah Rumah Yang Ditangani (ha)", rowspan: 2, width: "15%" },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Rehabilitasi Rumah" },
                { label: "Pembangunan Rumah Baru" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["kecamatan", "a", "b", "total"],
            sumColumns: ["a", "b", "total"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Bentuk Penanganan RTLH",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Rehabilitasi Rumah",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Pembangunan Rumah Baru",
                    type: "text",
                  },
                ],
              },
            ],
            showKec: true,
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);

            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 4
      // =========================
      if (id === 4) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", rowspan: 2, width: "5%" },
                { label: "Kecamatan", rowspan: 2, width: "12%" },
                { label: "Target Bentuk Penanganan RTLH", colspan: 2 },
                { label: "Target Jumlah Rumah Yang Ditangani (ha)", rowspan: 2, width: "15%" },
                { label: "Keterangan", rowspan: 2, width: "15%" },
                ...(!isCetak ? [{ label: "", rowspan: 2, width: "7%" }] : []),
              ],
              [
                { label: "Target Rehabilitasi Rumah" },
                { label: "Target Pembangunan Rumah Baru" },
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["kecamatan", "a", "b", "total"],
            sumColumns: ["a", "b", "total"],
            showTotal: false,
            showKet: true,
            showKec: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                title: "Target Bentuk Penanganan RTLH",
                cols: 2,
                fields: [
                  {
                    key: "a",
                    label: "Target Rehabilitasi Rumah",
                    type: "text",
                  },
                  {
                    key: "b",
                    label: "Target Pembangunan Rumah Baru",
                    type: "text",
                  },
                ],
              },
            ],
            showKec: true,
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {
            const a = num(row.a);
            const b = num(row.b);


            return {
              ...row,
              a,
              b,
              total: a + b,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 5
      // =========================
      if (id === 5) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama Perumahan" },
                { label: "Jenis Penyelenggaraan PSU" },
                { label: "Realisasi Pagu Anggaran"},
                { label: "Pembiayaan Dari" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu", "sumber"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: false,
            showKec: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Nama Perumahan",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Jenis Penyelenggaraan PSU",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Realisasi Pagu Anggaran",
                    type: "number",
                  },
                  {
                    key: "sumber",
                    label: "Pembiayaan Dari",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {

            return {
              ...row,

            };
          },
        };
      }

      // =========================
      // INDIKATOR 6
      // =========================
      if (id === 6) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Nama Perumahan yang direncakan mendapat bantuan" },
                { label: "No. Berita Acara Serah Terima PSU" },
                { label: "Pagu Anggaran"},
                { label: "Pembiayaan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu", "sumber"],
            sumColumns: ["a", "b"],
            showTotal: false,
            showKet: false,
            showKec: false,
            showAksi: !isCetak,
            showSubTotal: false,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Nama Perumahan yang direncakan mendapat bantuan",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "No. Berita Acara Serah Terima PSU",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Pagu Anggaran",
                    type: "number",
                  },
                  {
                    key: "sumber",
                    label: "Pembiayaan",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {

            return {
              ...row,

            };
          },
        };
      }

      // =========================
      // INDIKATOR 7
      // =========================
      if (id === 7) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Alamat Lokasi" },
                { label: "Peruntukan Tanah" },
                { label: "Luas M2"},
                { label: "No. Sertifikat" },
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu", "sumber"],
            sumColumns: ["pagu"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Alamat Lokasi",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Peruntukan Tanah",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Luas M2",
                    type: "number",
                  },
                  {
                    key: "sumber",
                    label: "No. Sertifikat",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {

            const pagu = num(row.pagu)

            return {
              ...row,
              pagu,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 8
      // =========================
      if (id === 8) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%", rowspan: 2 },
                { label: "Alamat Lokasi", rowspan: 2 },
                { label: "Peruntukan", rowspan: 2 },
                { label: "Luas M2", rowspan: 2},
                { label: "Status Aset Tanah", colspan: 3 },
                ...(!isCetak ? [{ label: "", width: "7%", rowspan: 2 }] : []),
              ],
              [
                { label: "Sudah Sertifikat" },
                { label: "Proses Sertifikat" },
                { label: "Belum Sertifikat"},
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu", "sudah" , "proses", "belum"],
            sumColumns: ["pagu"],
            showTotal: false,
            showKet: false,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Alamat Lokasi",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Peruntukan",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Luas M2",
                    type: "number",
                  },
                  {
                    key: "sumber",
                    label: "Status Aset Tanah",
                    type: "select",
                    options: [
                      { label: "Sudah Sertifikat", value: "1" },
                      { label: "Proses Sertifikat", value: "2" },
                      { label: "Belum Sertifikat", value: "3" },
                    ],
                  },
                ],
              },
            ],
            showKet: false,
          },

          // ===== CALC =====
          calcRow(row) {
            const pagu = num(row.pagu);
            const a = row.sumber == 1 ? 1 : row.sumber == 2 ? 2 : row.sumber == 3 ? 3 : 0; // 1 = memiliki, 2 = proses, 3 = belum

            return {
              ...row,
              pagu,
              sudah: a === 1 ? "✔" : "",
              proses: a === 2 ? "✔" : "",
              belum: a === 3 ? "✔" : ""
            };
          },
        };
      }


      // =========================
      // INDIKATOR 9
      // =========================
      if (id === 9) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Perangkat Daerah" },
                { label: "Peruntukkan Pola Ruang Eksisting" },
                { label: "Luas Tanah Yang Ditetapkan (M2)"},
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu"],
            sumColumns: ["pagu"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Perangkat Daerah",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Peruntukkan Pola Ruang Eksisting",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Luas Tanah Yang Ditetapkan (M2)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {

            const pagu = num(row.pagu)

            return {
              ...row,
              pagu,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 10
      // =========================
      if (id === 10) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Perangkat Daerah" },
                { label: "Peruntukkan Pola Ruang Dalam RTRW" },
                { label: "Luas Tanah Yang Ditetapkan (M2)"},
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu"],
            sumColumns: ["pagu"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Perangkat Daerah",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Peruntukkan Pola Ruang Dalam RTRW",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Luas Tanah Yang Ditetapkan (M2)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {

            const pagu = num(row.pagu)

            return {
              ...row,
              pagu,
            };
          },
        };
      }


      // =========================
      // INDIKATOR 11
      // =========================
      if (id === 11) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Perangkat Daerah" },
                { label: "Peruntukkan Pola Ruang Eksisting" },
                { label: "Luas Tanah Yang Ditetapkan (M2)"},
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu"],
            sumColumns: ["pagu"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Perangkat Daerah",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Peruntukkan Pola Ruang Eksisting",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Luas Tanah Yang Ditetapkan (M2)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {

            const pagu = num(row.pagu)

            return {
              ...row,
              pagu,
            };
          },
        };
      }

      // =========================
      // INDIKATOR 12
      // =========================
      if (id === 12) {
        return {
          id,

          // ===== TABLE =====
          table: {
            headRows: [
              [
                { label: "No", width: "5%" },
                { label: "Perangkat Daerah" },
                { label: "Peruntukkan Pola Ruang Dalam RTRW" },
                { label: "Luas Tanah Yang Ditetapkan (M2)"},
                { label: "Keterangan" },
                ...(!isCetak ? [{ label: "", width: "7%" }] : []),
              ],
            ],

            // jumlah1/jumlah2 hasil hitung
            bodyColumns: ["nama", "jenis", "pagu"],
            sumColumns: ["pagu"],
            showTotal: false,
            showKet: true,
            showAksi: !isCetak,
            showSubTotal: true,
            showGrandTotal: false,
          },

          // ===== FORM =====
          form: {
            groups: [
              {
                cols: 1,
                fields: [
                  {
                    key: "nama",
                    label: "Perangkat Daerah",
                    type: "text",
                  },
                  {
                    key: "jenis",
                    label: "Peruntukkan Pola Ruang Dalam RTRW",
                    type: "text",
                  },
                  {
                    key: "pagu",
                    label: "Luas Tanah Yang Ditetapkan (M2)",
                    type: "text",
                  },
                ],
              },
            ],
            showKet: true,
          },

          // ===== CALC =====
          calcRow(row) {

            const pagu = num(row.pagu)

            return {
              ...row,
              pagu,
            };
          },
        };
      }

      // =========================
      // DEFAULT
      // =========================
      return {
        id,
        table: {
          headRows: [],
          bodyColumns: [],
          showTotal: false,
          showKet: false,
          showAksi: !isCetak,
        },
        form: {
          groups: [],
          showKet: false,
        },
        calcRow: (row) => row,
      };
    },

    // ini dipakai untuk table view
    normalizedRows() {
      return (this.list_data || []).map(this.indikatorSchema.calcRow);
    },

    // ini dipakai untuk cetak
    normalizedCetakRows() {
      return (this.cetak_data || []).map(this.indikatorSchema.calcRow);
    },
  },

  methods: {
    formatNumber(val) {
    const num = Number(val);
    if (isNaN(num)) return val;

    // cek apakah punya desimal
    return Number.isInteger(num)
      ? num
      : num.toFixed(2);
  },
    getCellValue(row, key) {
      return row[key] ?? 0;
    },
    formatDate(val) {
      if (!val) return "-";

      const d = new Date(val);
      if (isNaN(d)) return val;

      return d.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    getView: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DPKP + "viewData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value,
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log("dasf");

          console.log(res_data);
          console.log("dasf");
          this.list_data = res_data.data;
          this.cetak_data = res_data.cetak;
          this.page_last = res_data.jml_data;
          this.$store.commit("hideLoading");
          this.nama_tahun = res_data.data[0].thn;
          this.indikator = res_data.data[0].indikator;
        });
    },

    getTotal: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_TOTAL + "DPKPData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({
          tahun: this.form.tahun.id,
          indikator: this.form.indikator.id,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.$store.commit("hideLoading");
          this.total1 = res_data.data[0].total1;
          this.total2 = res_data.data[0].total2;
          this.total3 = res_data.data[0].total3;
          this.total4 = res_data.data[0].total4;
          this.total5 = res_data.data[0].total5;
          this.total6 = res_data.data[0].total6;
          this.total7 = res_data.data[0].total7;
          this.total8 = res_data.data[0].total8;
          console.log(res_data);
        });
    },

    getKadis: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Unit + "kadis", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.nama_kadis = res_data[0].nama;
          this.nip_kadis = res_data[0].nip;
          this.pangkat_kadis = res_data[0].pangkat;
          this.gol_kadis = res_data[0].gol;
          this.ruang_kadis = res_data[0].ruang;
          this.gel_dep_kadis = res_data[0].gelar_depan;
          this.gel_bel_kadis = res_data[0].gelar_belakang;
          this.$store.commit("hideLoading");
        });
    },

    getKecamatan: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Kecamatan + "view", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_kecamatan = res_data;

          console.log(this.list_kecamatan);
          this.$store.commit("hideLoading");
        });
    },

    getTahun: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_Tahun, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_tahun = res_data;
          this.$store.commit("hideLoading");
        });
    },

    getIndikator: function () {
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_DPKP + "indikators", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
      })
        .then((res) => res.json())
        .then((res_data) => {
          console.log(res_data);
          this.list_indikator = res_data;
          this.$store.commit("hideLoading");
        });
    },
    printTable() {
      const printWindow = window.open("", "_blank");
      const content = document.getElementById("printCetak").innerHTML;

      const style = `
    <style>
      @page { margin: 10mm; }

      body {
        font-family: Arial, sans-serif;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        border-collapse: collapse;
      }

      th, td {
        border: 1px solid #ddd;
        padding: 5px;
        font-size: 11px;
        word-break: break-word;
        white-space: normal;
      }

      .text-center {
        text-align: center !important;
      }

      .print-wrapper {
        transform-origin: top left;
        display: inline-block;
      }
    </style>
  `;

      printWindow.document.open();
      printWindow.document.write(`
    <html>
      <head>
        <title>Dinas Perumahan, Kawasan Permukiman dan Pertanahan</title>
        ${style}
      </head>
      <body>
        <div id="wrapper" class="print-wrapper">
          ${content}
        </div>
      </body>
    </html>
  `);
      printWindow.document.close();

      printWindow.onload = function () {
        const wrapper = printWindow.document.getElementById("wrapper");

        // lebar halaman yang sedang aktif (portrait/landscape ikut user)
        const pageWidth = printWindow.innerWidth;

        // lebar tabel / konten
        const contentWidth = wrapper.scrollWidth;

        if (contentWidth > pageWidth) {
          const scale = pageWidth / contentWidth;
          wrapper.style.transform = `scale(${scale})`;
        } else {
          wrapper.style.transform = "scale(1)";
        }

        printWindow.focus();
        printWindow.print();
      };
    },
    addData: function () {
      // var formData = new FormData();
      // formData.append('data', JSON.stringify(this.form))
      fetch(this.$store.state.url.URL_DPKP + "addData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menambah Data",
          "light-blue-4",
          "check_circle_outline",
        );
        console.log(res_data);
        this.getView();
      });
    },

    editData: function () {
      console.log(this.form);
      fetch(this.$store.state.url.URL_DPKP + "editData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify(this.form),
      }).then((res_data) => {
        this.Notify("Sukses Merubah Data", "lime-7", "check_circle_outline");
        this.getView();
      });
    },

    removeData: function (a) {
      fetch(this.$store.state.url.URL_DPKP + "removeData", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token,
        },
        body: JSON.stringify({ id: a }),
      }).then((res_data) => {
        this.Notify(
          "Sukses Menghapus Data",
          "deep-orange-10",
          "check_circle_outline",
        );
        this.getView();
      });
    },

    selectData: function (data) {
      this.form.id = data.id;
      this.form.a = data.a;
      this.form.b = data.b;
      this.form.c = data.c;
      this.form.nama = data.nama;
      this.form.jenis = data.jenis;
      this.form.pagu = data.pagu;
      this.form.sumber = data.sumber;
      this.form.keterangan = data.keterangan;
      this.form.createAt = data.createAt;
    },

    // ====================================== PAGINATE ====================================
    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500,
      });
    },
    btn_prev: function () {
      this.cek_load_data = true;
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getView();
    },

    btn_next: function () {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getView();
    },

    cari_data: function () {
      this.page_first = 1;
      this.getView();
    },

    // ====================================== PAGINATE ====================================
  },

  mounted() {
    this.getView();
    this.getTahun();
    this.getKadis();
    this.getIndikator();
    this.getKecamatan();
  },
};
